import { type Scalars } from '../__generated-gql-types__/globalTypes';

import {
  GENERIC_EXPERIENCE_LEVELS,
  SPECIFIC_EXPERIENCE_LEVELS,
} from './constants';

export const getExperienceLevels = (
  categoryUrn: Scalars['CategoryUrn']['output'],
) => SPECIFIC_EXPERIENCE_LEVELS[categoryUrn] || GENERIC_EXPERIENCE_LEVELS;

export const getBucketCustomersCoached = (
  customersCoached: number,
): Nullable<string> => {
  if (customersCoached < 10) {
    return null;
  }
  if (customersCoached < 100) {
    return `${Math.floor(customersCoached / 10) * 10}+`;
  }
  if (customersCoached < 500) {
    return `${Math.floor(customersCoached / 50) * 50}+`;
  }
  return customersCoached < 1000 ? '500+' : '1000+';
};

export const getCoachUrl = ({
  coachSlug,
  categorySlug,
}: {
  coachSlug: Optional<string>;
  categorySlug: Possible<string>;
}) => {
  return `/coach/${coachSlug}${categorySlug ? `/${categorySlug}` : ''}`;
};

export const getCTATooltipTextForBlockedUser = (coachName?: string) =>
  `${coachName ?? 'Coach'} is unavailable for coaching.`;
